// Cricket Schedule Data - Extracted from FanCode Cricket Schedule Page

export interface TeamSquad {
  name: string;
  shortName: string;
  flag: string;
  score?: string;
  wickets?: number;
  overs?: string;
  isBatting?: boolean;
  isWinner?: boolean;
}

export interface CricketMatch {
  id: string;
  matchDesc: string;
  name: string;
  status: 'LIVE' | 'NOT_STARTED' | 'COMPLETED' | 'ABANDONED';
  streamingStatus: 'STARTED' | 'NOT_STARTED' | 'COMPLETED';
  startTime: string;
  venue: string;
  format: string;
  squads: TeamSquad[];
  scoreDescription?: string;
  tourId: string;
  tourName: string;
  tourSlug: string;
  matchSlug: string;
  sport: string;
}

export interface CricketTour {
  id: string;
  name: string;
  shortName: string;
  tourSlug: string;
  collectionId: number;
}

export interface TourWithMatches {
  tour: CricketTour;
  matches: CricketMatch[];
}

export interface ScheduleDay {
  date: string;
  label: string;
  tours: TourWithMatches[];
}

export const cricketTours: CricketTour[] = [
{ id: '53070', name: 'DP World ILT20 Development Tournament 2026', shortName: 'ILT20 Dev', tourSlug: 'dp-world-ilt20-development-tournament-2026-19881082', collectionId: 19881082 },
{ id: '53072', name: 'One Day Cup, 2026/27', shortName: 'One-Day Cup', tourSlug: 'one-day-cup-2026-27-19886489', collectionId: 19886489 },
{ id: '53080', name: 'Odisha T20 League 2026', shortName: 'Odisha T20', tourSlug: 'odisha-t20-league-2026-19892747', collectionId: 19892747 },
{ id: '53068', name: 'India tour of Japan, 2026', shortName: 'JPN vs IND', tourSlug: 'india-tour-of-japan-2026-19875418', collectionId: 19875418 },
{ id: '53026', name: 'Caribbean Premier League, 2026', shortName: 'CPL', tourSlug: 'caribbean-premier-league-2026', collectionId: 53026 },
{ id: '53039', name: 'India Tour of Afghanistan, 2026', shortName: 'AFG vs IND', tourSlug: 'india-tour-of-afghanistan-2026-19817039', collectionId: 19817039 },
{ id: '53069', name: 'World Championship of Legends, 2026', shortName: 'WCL', tourSlug: 'world-championship-of-legends-2026', collectionId: 53069 },
{ id: '53087', name: 'Sheffield Shield, 2026/27', shortName: 'Sheffield Shield', tourSlug: 'sheffield-shield-2026-27', collectionId: 53087 },
{ id: '53086', name: 'ICC CWC League 2 USA, 2026', shortName: 'ICC CWC League 2', tourSlug: 'icc-cwc-league-2-usa-2026', collectionId: 53086 },
{ id: '53091', name: "ICC Men's T20 WC Asia Sub-regional Qualifier A, 2026", shortName: 'ICC WC Sub-Regional A', tourSlug: 'icc-mens-t20-wc-asia-sub-regional-qualifier-a-2026', collectionId: 53091 },
{ id: '53092', name: "ICC Men's T20 WC Asia Sub-regional Qualifier B, 2026", shortName: 'ICC WC Sub-Regional B', tourSlug: 'icc-mens-t20-wc-asia-sub-regional-qualifier-b-2026', collectionId: 53092 },
{ id: '53093', name: "ICC Men's T20 WC Africa Sub-regional Qualifier C, 2026", shortName: 'ICC WC Africa Sub-Regional C', tourSlug: 'icc-mens-t20-wc-africa-sub-regional-qualifier-c-2026', collectionId: 53093 },
{ id: '53088', name: 'Bangladesh tour of Afghanistan in UAE, 2026', shortName: 'AFG vs BAN', tourSlug: 'bangladesh-tour-of-afghanistan-in-uae-2026', collectionId: 53088 },
{ id: '53089', name: 'Afghanistan, Bangladesh & Zimbabwe Tri Series, 2026', shortName: 'AFG vs BAN vs ZIM', tourSlug: 'afghanistan-bangladesh-zimbabwe-tri-series-2026', collectionId: 53089 },
{ id: '53094', name: 'Zimbabwe Tour of Afghanistan in UAE, 2026', shortName: 'AFG vs ZIM', tourSlug: 'zimbabwe-tour-of-afghanistan-in-uae-2026', collectionId: 53094 },
{ id: '53097', name: 'T20 Spring Challenge, 2026', shortName: 'T20 Spring Challenge', tourSlug: 't20-spring-challenge-2026', collectionId: 53097 },
{ id: '53074', name: 'West Indies tour of India, 2026', shortName: 'IND vs WI', tourSlug: 'west-indies-tour-of-india-2026', collectionId: 53074 },
{ id: '53075', name: "Women's National Cricket League, 2026/27", shortName: 'WNCL', tourSlug: 'womens-national-cricket-league-2026-27', collectionId: 53075 },
{ id: '53061', name: "Women's Caribbean Premier League, 2026", shortName: 'WCPL', tourSlug: 'womens-caribbean-premier-league-2026', collectionId: 53061 },
{ id: '53073', name: 'NCR T20 League, 2026', shortName: 'NCR T20', tourSlug: 'ncr-t20-league-2026', collectionId: 53073 },
{ id: '53050', name: "ACC Men's Premier Cup 2026", shortName: "ACC Men's Premier Cup", tourSlug: 'acc-mens-premier-cup-2026', collectionId: 53050 },
{ id: '53062', name: 'Australia tour of Zimbabwe, 2026', shortName: 'ZIM vs AUS', tourSlug: 'australia-tour-of-zimbabwe-2026', collectionId: 53062 },
{ id: '53058', name: 'Dehradun T20 League 2026', shortName: 'Dehradun T20', tourSlug: 'dehradun-t20-league-2026', collectionId: 53058 },
{ id: '53067', name: 'ILT20 Africa Continent Cup 2026', shortName: 'ILT20 ACC', tourSlug: 'ilt20-africa-continent-cup-2026', collectionId: 53067 },
{ id: '53052', name: 'Oman D50 2026', shortName: 'Oman D50', tourSlug: 'oman-d50-2026', collectionId: 53052 },
{ id: '53065', name: 'Sher-E-Punjab T20, 2026', shortName: 'Punjab T20', tourSlug: 'sher-e-punjab-t20-2026', collectionId: 53065 },
{ id: '53051', name: 'South Africa tour of Namibia, 2026', shortName: 'SA tour of NAM', tourSlug: 'south-africa-tour-of-namibia-2026', collectionId: 53051 },
{ id: '53071', name: 'United Arab Emirates tour of Malaysia, 2026', shortName: 'UAE tour of MAL', tourSlug: 'united-arab-emirates-tour-of-malaysia-2026', collectionId: 53071 }];


export const cricketScheduleData: ScheduleDay[] = [
{
  date: '2026-09-22',
  label: 'Yesterday',
  tours: [
  {
    tour: { id: '53072', name: 'One Day Cup, 2026/27', shortName: 'One-Day Cup', tourSlug: 'one-day-cup-2026-27-19886489', collectionId: 19886489 },
    matches: [
    {
      id: '4249277',
      matchDesc: 'Match 4',
      name: 'Queensland vs New South Wales',
      status: 'COMPLETED',
      streamingStatus: 'COMPLETED',
      startTime: '2026-09-22T04:00:00.000Z',
      venue: 'Allan Border Field',
      format: 'ODI',
      squads: [
      { name: 'Queensland', shortName: 'QUN', flag: 'https://images.fancode.com/skillup-uploads/cms-media/Queensland-Cricket.png', score: '358', wickets: 10, overs: '49.5', isBatting: false, isWinner: false },
      { name: 'New South Wales', shortName: 'NSW', flag: 'https://images.fancode.com/skillup-uploads/cms-media/New-South-Wales.png', score: '359', wickets: 6, overs: '49', isBatting: true, isWinner: true }],

      scoreDescription: 'New South Wales beat Queensland by 4 wickets',
      tourId: '53072', tourName: 'One Day Cup, 2026/27', tourSlug: 'one-day-cup-2026-27-19886489', matchSlug: 'queensland-vs-new-south-wales-4249277', sport: 'cricket'
    }]

  },
  {
    tour: { id: '53068', name: 'India tour of Japan, 2026', shortName: 'JPN vs IND', tourSlug: 'india-tour-of-japan-2026-19875418', collectionId: 19875418 },
    matches: [
    {
      id: '4249214',
      matchDesc: 'One-off T20I',
      name: 'India vs Japan',
      status: 'COMPLETED',
      streamingStatus: 'COMPLETED',
      startTime: '2026-09-22T04:00:00.000Z',
      venue: 'Sano International Cricket Ground',
      format: 'T20I',
      squads: [
      { name: 'India', shortName: 'IND', flag: 'https://d13ir53smqqeyp.cloudfront.net/flags/cr-flags/FC-IND@2x.png', score: '32', wickets: 4, overs: '5', isBatting: false, isWinner: true },
      { name: 'Japan', shortName: 'JPN', flag: 'https://d13ir53smqqeyp.cloudfront.net/flags/cr-flags/FC-JPN@2x.png', score: '30', wickets: 3, overs: '5', isBatting: true, isWinner: false }],

      scoreDescription: 'India beat Japan by 2 runs',
      tourId: '53068', tourName: 'India tour of Japan, 2026', tourSlug: 'india-tour-of-japan-2026-19875418', matchSlug: 'india-vs-japan-4249214', sport: 'cricket'
    }]

  },
  {
    tour: { id: '53080', name: 'Odisha T20 League 2026', shortName: 'Odisha T20', tourSlug: 'odisha-t20-league-2026-19892747', collectionId: 19892747 },
    matches: [
    {
      id: '4249574',
      matchDesc: 'Match 4',
      name: 'Puri Titans vs Kataka Panthers',
      status: 'ABANDONED',
      streamingStatus: 'COMPLETED',
      startTime: '2026-09-22T09:00:00.000Z',
      venue: 'Barabati Stadium',
      format: 'T20I',
      squads: [
      { name: 'Puri Titans', shortName: 'PUT', flag: 'https://images.fancode.com/skillup-uploads/cms-media/PutititansLogoFinal.png', isBatting: false },
      { name: 'Kataka Panthers', shortName: 'CUT', flag: 'https://d13ir53smqqeyp.cloudfront.net/flags/cr-flags/FC-CUT@2x.png', isBatting: false }],

      scoreDescription: 'Match Abandoned',
      tourId: '53080', tourName: 'Odisha T20 League 2026', tourSlug: 'odisha-t20-league-2026-19892747', matchSlug: 'puri-titans-vs-kataka-panthers-4249574', sport: 'cricket'
    },
    {
      id: '4249575',
      matchDesc: 'Match 5',
      name: 'Sambalpur Warriors vs Bhubaneshwar Tigers',
      status: 'ABANDONED',
      streamingStatus: 'COMPLETED',
      startTime: '2026-09-22T14:00:00.000Z',
      venue: 'Barabati Stadium',
      format: 'T20I',
      squads: [
      { name: 'Sambalpur Warriors', shortName: 'SAW', flag: 'https://d13ir53smqqeyp.cloudfront.net/flags/cr-flags/FC-SAW@2x.png', isBatting: false },
      { name: 'Bhubaneshwar Tigers', shortName: 'BBT', flag: 'https://d13ir53smqqeyp.cloudfront.net/flags/cr-flags/FC-BBTO@2x.png', isBatting: false }],

      scoreDescription: 'Match Abandoned',
      tourId: '53080', tourName: 'Odisha T20 League 2026', tourSlug: 'odisha-t20-league-2026-19892747', matchSlug: 'sambalpur-warriors-vs-bhubaneshwar-tigers-4249575', sport: 'cricket'
    }]

  },
  {
    tour: { id: '53070', name: 'DP World ILT20 Development Tournament 2026', shortName: 'ILT20 Dev', tourSlug: 'dp-world-ilt20-development-tournament-2026-19881082', collectionId: 19881082 },
    matches: [
    {
      id: '4249254',
      matchDesc: 'Match 14',
      name: 'MI Emirates Development vs Gulf Giants Development',
      status: 'COMPLETED',
      streamingStatus: 'COMPLETED',
      startTime: '2026-09-22T13:00:00.000Z',
      venue: 'ICC Academy, Dubai',
      format: 'T20I',
      squads: [
      { name: 'MI Emirates Development', shortName: 'MED', flag: 'https://images.fancode.com/skillup-uploads/cms-media/MIE_Development_team__cropped.png', isBatting: false },
      { name: 'Gulf Giants Development', shortName: 'GGD', flag: 'https://d13ir53smqqeyp.cloudfront.net/flags/cr-flags/FC-GGD@2x.png', isBatting: false }],

      scoreDescription: '',
      tourId: '53070', tourName: 'DP World ILT20 Development Tournament 2026', tourSlug: 'dp-world-ilt20-development-tournament-2026-19881082', matchSlug: 'mi-emirates-development-vs-gulf-giants-development-4249254', sport: 'cricket'
    }]

  }]

},
{
  date: '2026-09-23',
  label: 'Today',
  tours: [
  {
    tour: { id: '53070', name: 'DP World ILT20 Development Tournament 2026', shortName: 'ILT20 Dev', tourSlug: 'dp-world-ilt20-development-tournament-2026-19881082', collectionId: 19881082 },
    matches: [
    {
      id: '4249255',
      matchDesc: 'Match 15',
      name: 'Sharjah Warriorz Development vs Abu Dhabi Knight Riders Development',
      status: 'LIVE',
      streamingStatus: 'STARTED',
      startTime: '2026-09-23T09:00:00.000Z',
      venue: 'ICC Academy, Dubai',
      format: 'T20I',
      squads: [
      { name: 'Sharjah Warriorz Development', shortName: 'SWD', flag: "https://img.rocket.new/generatedImages/rocket_gen_img_4bc087185-1790109472024.png", isBatting: false },
      { name: 'Abu Dhabi Knight Riders Development', shortName: 'ADK', flag: "https://img.rocket.new/generatedImages/rocket_gen_img_4cf68a07b-1790109473838.png", isBatting: false }],

      scoreDescription: '',
      tourId: '53070', tourName: 'DP World ILT20 Development Tournament 2026', tourSlug: 'dp-world-ilt20-development-tournament-2026-19881082', matchSlug: 'sharjah-warriorz-development-vs-abu-dhabi-knight-riders-development-4249255', sport: 'cricket'
    },
    {
      id: '4249256',
      matchDesc: 'Match 16',
      name: 'Desert Vipers Development vs Dubai Capitals Development',
      status: 'NOT_STARTED',
      streamingStatus: 'NOT_STARTED',
      startTime: '2026-09-23T13:00:00.000Z',
      venue: 'ICC Academy, Dubai',
      format: 'T20I',
      squads: [
      { name: 'Desert Vipers Development', shortName: 'DVP', flag: "https://img.rocket.new/generatedImages/rocket_gen_img_4776d150e-1790109473353.png", isBatting: false },
      { name: 'Dubai Capitals Development', shortName: 'DCD', flag: "https://images.unsplash.com/photo-1503892728814-5d6f4aee37e0", isBatting: false }],

      scoreDescription: '',
      tourId: '53070', tourName: 'DP World ILT20 Development Tournament 2026', tourSlug: 'dp-world-ilt20-development-tournament-2026-19881082', matchSlug: 'desert-vipers-development-vs-dubai-capitals-development-4249256', sport: 'cricket'
    },
    {
      id: '4249257',
      matchDesc: 'Match 17',
      name: 'MI Emirates Development vs Sharjah Warriorz Development',
      status: 'NOT_STARTED',
      streamingStatus: 'NOT_STARTED',
      startTime: '2026-09-23T17:00:00.000Z',
      venue: 'ICC Academy, Dubai',
      format: 'T20I',
      squads: [
      { name: 'MI Emirates Development', shortName: 'MED', flag: 'https://images.fancode.com/skillup-uploads/cms-media/MIE_Development_team__cropped.png', isBatting: false },
      { name: 'Sharjah Warriorz Development', shortName: 'SWD', flag: "https://img.rocket.new/generatedImages/rocket_gen_img_4bc087185-1790109472024.png", isBatting: false }],

      scoreDescription: '',
      tourId: '53070', tourName: 'DP World ILT20 Development Tournament 2026', tourSlug: 'dp-world-ilt20-development-tournament-2026-19881082', matchSlug: 'mi-emirates-development-vs-sharjah-warriorz-development-4249257', sport: 'cricket'
    }]

  },
  {
    tour: { id: '53072', name: 'One Day Cup, 2026/27', shortName: 'One-Day Cup', tourSlug: 'one-day-cup-2026-27-19886489', collectionId: 19886489 },
    matches: [
    {
      id: '4249275',
      matchDesc: 'Match 5',
      name: 'South Australia vs Tasmania',
      status: 'NOT_STARTED',
      streamingStatus: 'NOT_STARTED',
      startTime: '2026-09-23T00:30:00.000Z',
      venue: 'Karen Rolton Oval',
      format: 'ODI',
      squads: [
      { name: 'South Australia', shortName: 'SAU', flag: 'https://images.fancode.com/skillup-uploads/cms-media/South-Australia-Cricket.png', isBatting: false },
      { name: 'Tasmania', shortName: 'TAS', flag: 'https://images.fancode.com/skillup-uploads/cms-media/Tasmania-Tigers.png', isBatting: false }],

      scoreDescription: '',
      tourId: '53072', tourName: 'One Day Cup, 2026/27', tourSlug: 'one-day-cup-2026-27-19886489', matchSlug: 'south-australia-vs-tasmania-4249275', sport: 'cricket'
    }]

  },
  {
    tour: { id: '53080', name: 'Odisha T20 League 2026', shortName: 'Odisha T20', tourSlug: 'odisha-t20-league-2026-19892747', collectionId: 19892747 },
    matches: [
    {
      id: '4249576',
      matchDesc: 'Match 6',
      name: 'Rourkela Superstars vs Puri Titans',
      status: 'NOT_STARTED',
      streamingStatus: 'NOT_STARTED',
      startTime: '2026-09-23T09:00:00.000Z',
      venue: 'Barabati Stadium',
      format: 'T20I',
      squads: [
      { name: 'Rourkela Superstars', shortName: 'ROR', flag: 'https://d13ir53smqqeyp.cloudfront.net/flags/cr-flags/FC-RORO@2x.png', isBatting: false },
      { name: 'Puri Titans', shortName: 'PUT', flag: 'https://images.fancode.com/skillup-uploads/cms-media/PutititansLogoFinal.png', isBatting: false }],

      scoreDescription: '',
      tourId: '53080', tourName: 'Odisha T20 League 2026', tourSlug: 'odisha-t20-league-2026-19892747', matchSlug: 'rourkela-superstars-vs-puri-titans-4249576', sport: 'cricket'
    },
    {
      id: '4249577',
      matchDesc: 'Match 7',
      name: 'Bhubaneshwar Tigers vs Kataka Panthers',
      status: 'NOT_STARTED',
      streamingStatus: 'NOT_STARTED',
      startTime: '2026-09-23T14:00:00.000Z',
      venue: 'Barabati Stadium',
      format: 'T20I',
      squads: [
      { name: 'Bhubaneshwar Tigers', shortName: 'BBT', flag: 'https://d13ir53smqqeyp.cloudfront.net/flags/cr-flags/FC-BBTO@2x.png', isBatting: false },
      { name: 'Kataka Panthers', shortName: 'CUT', flag: 'https://d13ir53smqqeyp.cloudfront.net/flags/cr-flags/FC-CUT@2x.png', isBatting: false }],

      scoreDescription: '',
      tourId: '53080', tourName: 'Odisha T20 League 2026', tourSlug: 'odisha-t20-league-2026-19892747', matchSlug: 'bhubaneshwar-tigers-vs-kataka-panthers-4249577', sport: 'cricket'
    }]

  }]

},
{
  date: '2026-09-24',
  label: 'Tomorrow',
  tours: [
  {
    tour: { id: '53072', name: 'One Day Cup, 2026/27', shortName: 'One-Day Cup', tourSlug: 'one-day-cup-2026-27-19886489', collectionId: 19886489 },
    matches: [
    {
      id: '4249276',
      matchDesc: 'Match 6',
      name: 'Victoria vs Western Australia',
      status: 'NOT_STARTED',
      streamingStatus: 'NOT_STARTED',
      startTime: '2026-09-24T04:00:00.000Z',
      venue: 'Junction Oval',
      format: 'ODI',
      squads: [
      { name: 'Victoria', shortName: 'VIC', flag: 'https://images.fancode.com/skillup-uploads/cms-media/Victoria-Cricket.png', isBatting: false },
      { name: 'Western Australia', shortName: 'WAU', flag: 'https://images.fancode.com/skillup-uploads/cms-media/Western-Australia-Cricket.png', isBatting: false }],

      scoreDescription: '',
      tourId: '53072', tourName: 'One Day Cup, 2026/27', tourSlug: 'one-day-cup-2026-27-19886489', matchSlug: 'victoria-vs-western-australia-4249276', sport: 'cricket'
    }]

  },
  {
    tour: { id: '53080', name: 'Odisha T20 League 2026', shortName: 'Odisha T20', tourSlug: 'odisha-t20-league-2026-19892747', collectionId: 19892747 },
    matches: [
    {
      id: '4249578',
      matchDesc: 'Match 8',
      name: 'Sambalpur Warriors vs Rourkela Superstars',
      status: 'NOT_STARTED',
      streamingStatus: 'NOT_STARTED',
      startTime: '2026-09-24T09:00:00.000Z',
      venue: 'Barabati Stadium',
      format: 'T20I',
      squads: [
      { name: 'Sambalpur Warriors', shortName: 'SAW', flag: 'https://d13ir53smqqeyp.cloudfront.net/flags/cr-flags/FC-SAW@2x.png', isBatting: false },
      { name: 'Rourkela Superstars', shortName: 'ROR', flag: 'https://d13ir53smqqeyp.cloudfront.net/flags/cr-flags/FC-RORO@2x.png', isBatting: false }],

      scoreDescription: '',
      tourId: '53080', tourName: 'Odisha T20 League 2026', tourSlug: 'odisha-t20-league-2026-19892747', matchSlug: 'sambalpur-warriors-vs-rourkela-superstars-4249578', sport: 'cricket'
    }]

  },
  {
    tour: { id: '53068', name: 'India tour of Japan, 2026', shortName: 'JPN vs IND', tourSlug: 'india-tour-of-japan-2026-19875418', collectionId: 19875418 },
    matches: [
    {
      id: '4249215',
      matchDesc: '1st T20I',
      name: 'India vs Japan',
      status: 'NOT_STARTED',
      streamingStatus: 'NOT_STARTED',
      startTime: '2026-09-24T08:00:00.000Z',
      venue: 'Sano International Cricket Ground',
      format: 'T20I',
      squads: [
      { name: 'India', shortName: 'IND', flag: 'https://d13ir53smqqeyp.cloudfront.net/flags/cr-flags/FC-IND@2x.png', isBatting: false },
      { name: 'Japan', shortName: 'JPN', flag: 'https://d13ir53smqqeyp.cloudfront.net/flags/cr-flags/FC-JPN@2x.png', isBatting: false }],

      scoreDescription: '',
      tourId: '53068', tourName: 'India tour of Japan, 2026', tourSlug: 'india-tour-of-japan-2026-19875418', matchSlug: 'india-vs-japan-4249215', sport: 'cricket'
    }]

  },
  {
    tour: { id: '53039', name: 'India Tour of Afghanistan, 2026', shortName: 'AFG vs IND', tourSlug: 'india-tour-of-afghanistan-2026-19817039', collectionId: 19817039 },
    matches: [
    {
      id: '4249300',
      matchDesc: '1st ODI',
      name: 'Afghanistan vs India',
      status: 'NOT_STARTED',
      streamingStatus: 'NOT_STARTED',
      startTime: '2026-09-24T10:00:00.000Z',
      venue: 'Sharjah Cricket Stadium',
      format: 'ODI',
      squads: [
      { name: 'Afghanistan', shortName: 'AFG', flag: 'https://d13ir53smqqeyp.cloudfront.net/flags/cr-flags/FC-AFG@2x.png', isBatting: false },
      { name: 'India', shortName: 'IND', flag: 'https://d13ir53smqqeyp.cloudfront.net/flags/cr-flags/FC-IND@2x.png', isBatting: false }],

      scoreDescription: '',
      tourId: '53039', tourName: 'India Tour of Afghanistan, 2026', tourSlug: 'india-tour-of-afghanistan-2026-19817039', matchSlug: 'afghanistan-vs-india-4249300', sport: 'cricket'
    }]

  }]

},
{
  date: '2026-09-25',
  label: '25 Sep',
  tours: [
  {
    tour: { id: '53069', name: 'World Championship of Legends, 2026', shortName: 'WCL', tourSlug: 'world-championship-of-legends-2026', collectionId: 53069 },
    matches: [
    {
      id: '4249400',
      matchDesc: 'Match 1',
      name: 'India Champions vs Pakistan Champions',
      status: 'NOT_STARTED',
      streamingStatus: 'NOT_STARTED',
      startTime: '2026-09-25T14:00:00.000Z',
      venue: 'Edgbaston, Birmingham',
      format: 'T20',
      squads: [
      { name: 'India Champions', shortName: 'INC', flag: 'https://d13ir53smqqeyp.cloudfront.net/flags/cr-flags/FC-IND@2x.png', isBatting: false },
      { name: 'Pakistan Champions', shortName: 'PKC', flag: 'https://d13ir53smqqeyp.cloudfront.net/flags/cr-flags/FC-PAK@2x.png', isBatting: false }],

      scoreDescription: '',
      tourId: '53069', tourName: 'World Championship of Legends, 2026', tourSlug: 'world-championship-of-legends-2026', matchSlug: 'india-champions-vs-pakistan-champions-4249400', sport: 'cricket'
    }]

  },
  {
    tour: { id: '53039', name: 'India Tour of Afghanistan, 2026', shortName: 'AFG vs IND', tourSlug: 'india-tour-of-afghanistan-2026-19817039', collectionId: 19817039 },
    matches: [
    {
      id: '4249301',
      matchDesc: '2nd ODI',
      name: 'Afghanistan vs India',
      status: 'NOT_STARTED',
      streamingStatus: 'NOT_STARTED',
      startTime: '2026-09-25T10:00:00.000Z',
      venue: 'Sharjah Cricket Stadium',
      format: 'ODI',
      squads: [
      { name: 'Afghanistan', shortName: 'AFG', flag: 'https://d13ir53smqqeyp.cloudfront.net/flags/cr-flags/FC-AFG@2x.png', isBatting: false },
      { name: 'India', shortName: 'IND', flag: 'https://d13ir53smqqeyp.cloudfront.net/flags/cr-flags/FC-IND@2x.png', isBatting: false }],

      scoreDescription: '',
      tourId: '53039', tourName: 'India Tour of Afghanistan, 2026', tourSlug: 'india-tour-of-afghanistan-2026-19817039', matchSlug: 'afghanistan-vs-india-4249301', sport: 'cricket'
    }]

  }]

},
{
  date: '2026-09-26',
  label: '26 Sep',
  tours: [
  {
    tour: { id: '53026', name: 'Caribbean Premier League, 2026', shortName: 'CPL', tourSlug: 'caribbean-premier-league-2026', collectionId: 53026 },
    matches: [
    {
      id: '4249500',
      matchDesc: 'Match 22',
      name: 'Trinbago Knight Riders vs Barbados Royals',
      status: 'NOT_STARTED',
      streamingStatus: 'NOT_STARTED',
      startTime: '2026-09-26T23:00:00.000Z',
      venue: 'Queen\'s Park Oval, Trinidad',
      format: 'T20',
      squads: [
      { name: 'Trinbago Knight Riders', shortName: 'TKR', flag: 'https://d13ir53smqqeyp.cloudfront.net/flags/cr-flags/FC-TKR@2x.png', isBatting: false },
      { name: 'Barbados Royals', shortName: 'BR', flag: 'https://d13ir53smqqeyp.cloudfront.net/flags/cr-flags/FC-BR@2x.png', isBatting: false }],

      scoreDescription: '',
      tourId: '53026', tourName: 'Caribbean Premier League, 2026', tourSlug: 'caribbean-premier-league-2026', matchSlug: 'trinbago-knight-riders-vs-barbados-royals-4249500', sport: 'cricket'
    }]

  },
  {
    tour: { id: '53069', name: 'World Championship of Legends, 2026', shortName: 'WCL', tourSlug: 'world-championship-of-legends-2026', collectionId: 53069 },
    matches: [
    {
      id: '4249401',
      matchDesc: 'Match 2',
      name: 'Australia Champions vs England Champions',
      status: 'NOT_STARTED',
      streamingStatus: 'NOT_STARTED',
      startTime: '2026-09-26T14:00:00.000Z',
      venue: 'Edgbaston, Birmingham',
      format: 'T20',
      squads: [
      { name: 'Australia Champions', shortName: 'AUC', flag: 'https://d13ir53smqqeyp.cloudfront.net/flags/cr-flags/FC-AUS@2x.png', isBatting: false },
      { name: 'England Champions', shortName: 'ENC', flag: 'https://d13ir53smqqeyp.cloudfront.net/flags/cr-flags/FC-ENG@2x.png', isBatting: false }],

      scoreDescription: '',
      tourId: '53069', tourName: 'World Championship of Legends, 2026', tourSlug: 'world-championship-of-legends-2026', matchSlug: 'australia-champions-vs-england-champions-4249401', sport: 'cricket'
    }]

  }]

}];


export function formatMatchTime(startTime: string): {time: string;ampm: string;} {
  const date = new Date(startTime);
  const istOffset = 5.5 * 60 * 60 * 1000;
  const istDate = new Date(date.getTime() + istOffset);
  let hours = istDate.getUTCHours();
  const minutes = istDate.getUTCMinutes();
  const ampm = hours >= 12 ? 'PM' : 'AM';
  hours = hours % 12;
  if (hours === 0) hours = 12;
  const minuteStr = minutes === 0 ? '00' : minutes.toString().padStart(2, '0');
  return { time: `${hours}:${minuteStr}`, ampm };
}

export function getDateLabel(dateStr: string): string {
  const today = new Date();
  const todayStr = today.toISOString().split('T')[0];
  const tomorrow = new Date(today);
  tomorrow.setDate(tomorrow.getDate() + 1);
  const tomorrowStr = tomorrow.toISOString().split('T')[0];
  const yesterday = new Date(today);
  yesterday.setDate(yesterday.getDate() - 1);
  const yesterdayStr = yesterday.toISOString().split('T')[0];

  if (dateStr === todayStr) return 'Today';
  if (dateStr === tomorrowStr) return 'Tomorrow';
  if (dateStr === yesterdayStr) return 'Yesterday';

  const date = new Date(dateStr);
  const day = date.getDate();
  const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  return `${day} ${months[date.getMonth()]}`;
}